'use strict';

module.exports = function isNotEmpty() {
  return !!this.items.length;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/isNotEmpty.js
// module id = 1238
// module chunks = 2